import { Status } from "@covertree/ui/content/StatusLabel";
import { RenewalStatus } from "@covertree/agent-portal-graphql";

export function mapRenewalStatusLabel(status?: RenewalStatus): Status {
  switch (status ?? "") {
    case RenewalStatus.Upcoming:
    case RenewalStatus.UwReview:
    case RenewalStatus.UwAccepted:
    case RenewalStatus.OfferSent:
      return "pending";

    case RenewalStatus.Discarded:
    case RenewalStatus.PricingFailed:
    case RenewalStatus.PaymentFailed:
    case RenewalStatus.UwFailed:
    case RenewalStatus.OfferSentFailed:
      return "expired";
    case RenewalStatus.Issued:
    case RenewalStatus.NonRenewalIssued:
      return "active";
    default:
      return "initial";
  }
}
